import '../styles/heatmap.css';

import {
  flexRender,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table';
import {format} from 'date-fns';

import {EmployeeNameCell} from '../../../common';

const RecordStatus = {
  Hazardous: 1,
  Elevated_1: 2.4,
  Elevated_2: 2.3,
  Elevated_3: 2.2,
  Elevated_4: 2.1,
  Good: 3,
  Missing: 4,
  Baseline: 5,
};

const statusMap = {
  [RecordStatus.Hazardous]: 'red',
  [RecordStatus.Elevated_1]: 'elevated_1',
  [RecordStatus.Elevated_2]: 'elevated_2',
  [RecordStatus.Elevated_3]: 'elevated_3',
  [RecordStatus.Elevated_4]: 'elevated_4',
  [RecordStatus.Good]: 'green',
  [RecordStatus.Missing]: 'striped',
  [RecordStatus.Baseline]: 'grey',
};

const getStatusByDate = (recordings, dateKey) => {
  const rec = recordings.find((r) => r.date === dateKey && r.status_code !== 4);
  return rec?.status_code ?? RecordStatus.Missing;
};

export const HeatmapTable = ({data, dates}) => {
  const columns = [
    {
      header: null,
      accessorKey: 'name',
      cell: (info) => <EmployeeNameCell name={info.getValue()} />,
    },
    ...dates.map((date) => {
      const key = format(date, 'yyyy-MM-dd');

      return {
        id: key,
        header: () => format(date, 'EEE MM/dd/yy'),
        cell: ({row}) => {
          const statusKey = getStatusByDate(row.original.recordings, key);

          return <div className={`cell ${statusMap[statusKey]}`} />;
        },
      };
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className='heatmap-scroll'>
      <table className='heatmap-table'>
        <thead>
          {table.getHeaderGroups().map((hg) => (
            <tr key={hg.id}>
              {hg.headers.map((header) => (
                <th key={header.id}>
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext(),
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell) => (
                <td key={cell.id}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
